import { render } from "./ConfirmAccountForm.vue?vue&type=template&id=17164710&lang=en"
import script from "./ConfirmAccountForm.vue?vue&type=script&lang=js"
export * from "./ConfirmAccountForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__